import { getFullAnalytics3d, getMockupAnalytics3d} from '../../api';
import {createAsyncThunk} from "@reduxjs/toolkit";
import store from "../../store";
import {setNotifications} from "../slices/notifications";

export const getAnalytics3d = createAsyncThunk(
    'analytics3d/getAnalytics3d',
    async (queryParams: any, {rejectWithValue}) => {
        try {
            const analytics3d = await getFullAnalytics3d(queryParams);
            return analytics3d;
        } catch (error: any) {
            store.dispatch(setNotifications({text: error.message, type: 'error'}))
            return rejectWithValue(error.message)
        }
    }
);

export const getMockups3d = createAsyncThunk(
    'analytics3d/getMockupsAnalytics3d',
    async (queryParams: any, {rejectWithValue}) => {
        try {
            const mockups= await getMockupAnalytics3d(queryParams);
            return mockups;
        } catch (error: any) {
            store.dispatch(setNotifications({text: error.message, type: 'error'}))
            return rejectWithValue(error.message)
        }
    }
);
export const addMockups3d = createAsyncThunk(
    'analytics3d/addMockupsAnalytics3d',
    async (queryParams: any, {rejectWithValue}) => {
        try {
            const mockups= await getMockupAnalytics3d(queryParams);
            return mockups;
        } catch (error: any) {
            store.dispatch(setNotifications({text: error.message, type: 'error'}))
            return rejectWithValue(error.message)
        }
    }
);

